import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import SampleForm from "@/components/SampleForm";

export default function SampleDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="sample-dialog" className="bg-[#121315] border border-[#8C7355]/25 text-[#F5F4F0] sm:max-w-xl p-8 md:p-10 max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <p className="text-[#C9A876] text-[10px] tracking-[0.4em] uppercase">Architect &amp; Designer Trade Portal</p>
          <DialogTitle className="font-serif-display font-light tracking-tight text-3xl md:text-4xl text-[#F5F4F0]">Request Sample</DialogTitle>
          <DialogDescription className="text-[#D6D1CA]/55 font-body">
            Share your project. Our studio team will curate a sample kit and be in touch to organise delivery.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4">
          <SampleForm onDone={() => onOpenChange(false)} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
